import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from "../../Header";
import Footer from "../../Footer";
import ZaptranceSideNav from './ZaptranceSideNav';
import HeaderZaptrance from './HeaderZaptrance';

import icon from '@mui/icons-material/Home';
import HelpIcon from '@mui/icons-material/HelpOutline';


import axios from 'axios';

import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import DisabledByDefaultOutlinedIcon from '@mui/icons-material/DisabledByDefaultOutlined';
import PendingActionsOutlinedIcon from '@mui/icons-material/PendingActionsOutlined';
import DeleteIcon from '@mui/icons-material/DeleteForeverOutlined';
import EditIcon from '@mui/icons-material/ModeOutlined';
import FilterIcon from '@mui/icons-material/FilterListOutlined';

const ZaptranceVerificationRequest = () => {
  const navigate = useNavigate();

      // Define state variables to store data
  const [guestVerifications, setGuestVerifications] = useState([]);
  const [loading, setLoading] = useState(true);

  const [approvedVerifications, setApprovedVerifications] = useState([]);
  const [declinedVerifications, setDeclinedVerifications] = useState([]);
  const [pendingVerifications, setPendingVerifications] = useState([]);


  // pagination & search
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(guestVerifications ? guestVerifications.length : 0);

  const [searchQuery, setSearchQuery] = useState('');
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };
  const filteredGuestVerifications = guestVerifications.filter((guestVerification) =>
  // guestVerification.fullname.toLowerCase().includes(searchQuery.toLowerCase())

  guestVerification.fullname.toLowerCase().includes(searchQuery.toLowerCase()) ||
  guestVerification.status.toLowerCase().includes(searchQuery.toLowerCase()) ||
  guestVerification.email.toLowerCase().includes(searchQuery.toLowerCase())

  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentFilteredGuestVerifications = filteredGuestVerifications ? filteredGuestVerifications.slice(indexOfFirstItem, indexOfLastItem) : [];
  let countGuests = indexOfFirstItem + 1;
  // pagination & search

  
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedGuest, setSelectedGuest] = useState([]);


  let token = localStorage.getItem('token');
  useEffect(() => {
    if (!token) {
      // Redirect to the home page if the token is null
      navigate('/');
    } else {
      // If the user is authenticated, call the handleData function
      handleData();
    }
  }, [navigate]);




    const handleData = async () => { // Receive the token as an argument
        try {
          // Make the API request to obtain the data
          const response = await axios.get('https://gacsstage.zaptrance.ng/api/admin/guests', {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          });
    
          // Check if the request was successful
          if (response.data.success) {
            //alert("guest: " + JSON.stringify(response.data.data, null, 2));
            

            // Store the retrieved data in state
            setGuestVerifications(response.data.data);
            setTotalItems(response.data.data.length);

            const approved = response.data.data.filter(guest => guest.status === 'verified');
        const declined = response.data.data.filter(guest => guest.status === 'declined');
        const pending = response.data.data.filter(guest => guest.status === 'pending');

        // Store the separated data in state
        setApprovedVerifications(approved);
        setDeclinedVerifications(declined);
        setPendingVerifications(pending);



            setLoading(false); // Set loading to false when data is received
          } else {
            // Handle the case where the request was not successful
            alert('Request failed:' + response.data.message);
          }
        } catch (error) {
          alert('Request error:'+ error);
          // Handle request error, e.g., display an error message to the user
        }
      };

      

      const handleEditOnClick = (guest, e) => {
        e.stopPropagation();
        //alert(JSON.stringify(institution, null, 2));
        //alert(registration.id);
    
        setSelectedRow(guest);
        setSelectedGuest(guest);
        
        //alert(institution.name);
    
        //alert(programTypes);
        //alert(JSON.stringify(programTypes, null, 2));
        //return;
        
        // setIsAddProgramModalOpen(true);
        // navigate(`/zaptrance-institution-detail/${institution}`);
    
        const guestString = JSON.stringify(guest);
        // Navigate to the detail page with the serialized institution as a parameter
        const additionalVariable = 'edit';
        //navigate(`/zaptrance-institution-detail/${encodeURIComponent(institutionString)}`);
        navigate(`/zaptrance-verification-request/${encodeURIComponent(guestString)}/${additionalVariable}`);
    
      };

      


      const handleRowClick = (guest, e) => {
    
        //alert(JSON.stringify(user, null, 2));
        //alert(registration.id);
    
        setSelectedRow(guest);
        setSelectedGuest(guest);
        
        //alert(institution.name);
    
        //alert(programTypes);
        //alert(JSON.stringify(programTypes, null, 2));
        //return;
        
        // setIsAddProgramModalOpen(true);
        // navigate(`/zaptrance-institution-detail/${institution}`);
    
        const guestString = JSON.stringify(guest);
        const additionalVariable = 'noEdit';
        navigate(`/zaptrance-verification-request/${encodeURIComponent(guestString)}/${additionalVariable}`);
    
      };




    return (
      <div className="content flex-grow">
      <div className="inner-content">
          <HeaderZaptrance />
          <div className=' p-4' style={{ backgroundColor: '#F6F7FB' }}>
          <div className='text-black p-4 flex text-xl'>
                  <div><HelpIcon className='mr-4'/></div>Verification Request
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-6">
                  <div className="rounded-lg p-4 flex-1 m-2 flex-col text-black" style={{ backgroundColor: '#CCF8FE' }}>
                      <h1 style={{ fontSize: '32px', fontWeight: 'bold' }} className="py-2">
                          {approvedVerifications.length}
                      </h1>
                      <div><VerifiedOutlinedIcon className='mr-4'/>Approved Verifications</div>
                  </div>
                  <div className="rounded-lg bg-gray-300 p-4 flex-1 m-2 flex-col text-black" style={{ backgroundColor: '#FFE5D3' }}>
                      <h1 style={{ fontSize: '32px', fontWeight: 'bold' }} className="py-2">
                        {declinedVerifications.length}
                      </h1>
                      <div><DisabledByDefaultOutlinedIcon className='mr-4'/>Declined Verifications</div>
                  </div>
                  <div className="rounded-lg bg-gray-300 p-4 flex-1 m-2 flex-col text-black" style={{ backgroundColor: '#FFF5CC' }}>
                      <h1 style={{ fontSize: '32px', fontWeight: 'bold' }} className="py-2">
                        {pendingVerifications.length}
                      </h1>
                      <div><PendingActionsOutlinedIcon className='mr-4'/>Pending Verifications</div>
                  </div>
              </div>

              <div className="flex justify-between my-2 pb-2 pl-2">
<div className="flex items-center">
<div className="text-xl">Request List</div>
</div>
<div className="flex items-center">
<input
type="text"
placeholder="Search"
className="border border-gray-300 rounded-lg py-1 px-2 mr-4"
onChange={handleSearchChange}
/>
<div className="flex items-center">
<FilterIcon className="text-gray-500 cursor-pointer" />
<span className="text-gray-500 ml-1">Filter Search</span>
</div>
</div>
</div>



                      
<div className="overflow-x-auto">
      <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
        <thead>
          <tr>
            <th style={{backgroundColor: '#095918'}} className="px-6 py-3 border-b border-gray-300 text-left text-xs leading-4 font-medium text-white uppercase tracking-wider">
              SN
            </th>
            <th style={{backgroundColor: '#095918'}} className="px-6 py-3 border-b border-gray-300 text-left text-xs leading-4 font-medium text-white uppercase tracking-wider">
              Fullname
            </th>
            <th style={{backgroundColor: '#095918'}} className="px-6 py-3 border-b border-gray-300 text-center text-xs leading-4 font-medium text-white uppercase tracking-wider">
              Status
            </th>
            <th style={{backgroundColor: '#095918'}} className="px-6 py-3 border-b border-gray-300 text-center text-xs leading-4 font-medium text-white uppercase tracking-wider">
              Action
            </th>
            <th style={{backgroundColor: '#095918'}} className="px-6 py-3 border-b border-gray-300 text-left text-xs leading-4 font-medium text-white uppercase tracking-wider">
              Email
            </th>
          </tr>
        </thead>
        <tbody>
          {currentFilteredGuestVerifications.map((guestVerification) => (
            <tr key={guestVerification.id} onClick={(e) => handleRowClick(guestVerification, e)} style={{ cursor: "pointer" }}>
              <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
              {countGuests++} {/* {user.id} */}
              </td>
              <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
                {guestVerification.fullname}
              </td>
              <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 " >
                <div className="text-center px-2 py-1" style={{ 
                  borderRadius: '10px', 
                  color: guestVerification.status === 'verified' ? 'green' : 'red',
                  background: '#eeeeee' }}>{guestVerification.status}
                  </div>
              </td>                        
              <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-center ">
                <span className="px-2 py-1" style={{ color: 'green' }} onClick={(e) => handleEditOnClick(guestVerification, e)} ><EditIcon /></span>
                {/* <span className="mr-4" 
                style={{ color:  institution.status === 'active' ? 'green' : 'red' }} onClick={(e) => handleChangeDataClick(institution, e)} >{ institution.status === 'active' ? <ToggleOnIcon /> : <ToggleOffIcon />}</span>
                <span className="" style={{ color: 'green' }}>More</span> */}
                
              </td>                      
              <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
                {guestVerification.email}
              </td>
              
              {/* <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
                <span className="mr-3" style={{ color: 'green' }}><EditIcon /></span>
                <span className="mr-3" style={{ color: 'red' }}><DeleteIcon /></span>
                <span className="" style={{ color: 'green' }}>More</span>
                
              </td> */}
            </tr>
          ))}
        </tbody>
      </table>
    </div>

              

              {/* Pagination Controls */}
<div className="flex justify-center mt-4">
<button
onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
disabled={currentPage === 1}
className="px-4 py-2 mr-2 bg-gray-300 hover:bg-nbteGreen hover:text-white transition-colors duration-300"
style={{width: '100px', borderRadius: '30px',}}
>
Previous
</button>
<button
onClick={() => setCurrentPage((prev) => Math.min(prev + 1, Math.ceil(totalItems / itemsPerPage)))}
disabled={currentPage === Math.ceil(totalItems / itemsPerPage)}
className="px-4 py-2 bg-gray-300 hover:bg-nbteGreen hover:text-white transition-colors duration-300"
style={{width: '100px', borderRadius: '30px',}}
>
Next
</button>
</div>


              
          </div>
      </div>
  </div>
    );
}

export default ZaptranceVerificationRequest;
